module.exports = __webpack_public_path__ + "img/car_category.722fbd9d.svg";